import Req from '../../$axios';

const serviceModule = {
  // 项目列表
  getProjectList(params) {
    return Req({
      url: 'project/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: false,
    },
      params,
    );
  },
  // 获取动态信息接口
  getDynamicList(params) {
    return Req({
      url: 'projectDynamics/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: false,
    },
      params,
    );
  },
  getDynamicIndex(params) {
    return Req({
      url: 'projectMessages/dynamicIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: false,
    },
      params,
    );
  }
};

export default {
  ...serviceModule
};
